import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Tables from "../pages/Tables/Tables";
import ProTables from "../pages/Tables/ProTables";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const tablesRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/tables/tables"
      element={
        <>
          <PageTitle title="Tables | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <Tables />
        </>
      }
    />
    <Route
      path="/tables/pro-tables"
      element={
        <>
          <PageTitle title="Pro Tables | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <ProTables />
        </>
      }
    />
  </Route>
);

export default tablesRoutes;
